export default __webpack_public_path__ + "static/media/creditCardReader.1f865ec1.svg";